import * as widgetConfigActions from "@dashboard-widget/actions/dashboard-widget-config.actions";
import { Injectable } from "@angular/core";
import {
  DebtorAccountHistoryWidgetConfiguration,
  SaveDebtorAccountHistoryWidgetConfigurationRequest,
  DebtorAccountHistorySequence
} from "@feature/_app_modules/debtor-account-history-widget/debtor-account-history-widget-types";
import {ActionDispatcher} from "@store/dispatcher.service";
import {mapWherePropertiesMatch, UrlBuilderService} from "@feature/common";
import { HttpClient } from "@angular/common/http";
import * as dashboardWidgetConfigSelectors from "@dashboard-widget/selectors/dashboard-widget-config.selectors";
import { select, Store } from '@ngrx/store';
import { map, filter, distinctUntilChanged, Observable } from 'rxjs';
import { WidgetConfiguration } from "@feature/widget-configs";

@Injectable({
  providedIn: 'root'
})
export class DebtorAccountHistoryWidgetConfigService {

  readonly widgetConfigControllerUrl : string;

  constructor(
    private readonly dispatcher: ActionDispatcher,
    private readonly urlProvider: UrlBuilderService,
    private readonly http: HttpClient,
    private readonly store: Store<any>,
  ) {
    this.widgetConfigControllerUrl = this.urlProvider.getUrl('debtor-account-history-widget/config');
  }

  getUserWidgetConfig(widgetId: number) : Observable<DebtorAccountHistoryWidgetConfiguration> {
    return this.store.pipe(
      select(dashboardWidgetConfigSelectors.getDashboardWidgetConfig(widgetId)),
      filter(d => d !== undefined),
      map(c => c
        ? c.ConfigurationObject as DebtorAccountHistoryWidgetConfiguration
        : null),
      distinctUntilChanged()
    );
  }

  getAdminWidgetConfig(widgetConfigurationId: number) : Observable<DebtorAccountHistoryWidgetConfiguration> {
    const url : string = `${this.widgetConfigControllerUrl}/${widgetConfigurationId}`;
    return this.http.get<DebtorAccountHistoryWidgetConfiguration>(url);
  }

  saveUserWidgetConfig(
    widgetId: number,
    sequence: number) : void {
    this.dispatcher.dispatch(
      widgetConfigActions.saveDashboardWidgetConfiguration({
        widgetId: widgetId,
        config: <DebtorAccountHistoryWidgetConfiguration> { Sequence: sequence }
      }));
  }

  saveAdminWidgetConfig(widgetConfig: WidgetConfiguration,
                        adminFormValue: any) : Observable<Object> {
    const url: string = this.widgetConfigControllerUrl;
    const request = this.createRequest(widgetConfig, adminFormValue);
    return this.http.post(url, request);
  }

  createCopyOfAdminWidgetConfig(widgetConfig: WidgetConfiguration,
                                adminFormValue: any) : Observable<Object> {
    const url: string = `${this.widgetConfigControllerUrl}/copy`;
    const request = this.createRequest(widgetConfig, adminFormValue);
    return this.http.post(url, request);
  }

  private createRequest(widgetConfig: WidgetConfiguration, adminFormValue: any) : SaveDebtorAccountHistoryWidgetConfigurationRequest  {
    return {
      DebtorAccountHistoryWidgetConfiguration: { Sequence: adminFormValue?.Sequence ?? DebtorAccountHistorySequence.SortByDateForEachReceipt, },
      WidgetConfiguration: mapWherePropertiesMatch(widgetConfig, adminFormValue),
    };
  }
}
